<template>
  <div class="latest-recommendations">
    <div class="header">
      Latest Recommendations
      <span class="view-all" @click="$router.push('/experts-past-recommendations')">View all ({{ recommendations ? recommendations.length : 0 }})</span>
    </div>

    <div v-if="isRecoListLoading">
      <el-row class="scroll-container" :gutter="20">
        <el-col :span="6" v-for="(item, index) in 5" :key="index">
          <el-card class="recommendation-card" :body-style="{ padding: '10px' }">
            <el-skeleton :rows="3" animated />
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div v-else-if="recommendations && recommendations.length > 0">
      <div class="carousel-items">
        <el-carousel :interval="3000" arrow="never" indicator-position="outside" height="auto" :autoplay="false">
          <el-carousel-item v-for="(group, index) in chunkedRecommendations" :key="index">
            <el-row class="scroll-container" :gutter="20" justify="flex-start">
              <el-col v-for="(recommendation, i) in group" :key="i" :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 6 }" :lg="{ span: 6 }" :xl="{ span: 6 }">
                <el-card class="recommendation-card" :body-style="{ padding: '10px' }" :style="{ borderRight: '3px solid ' + getBorderColor(recommendation.risk_tag) }" @click.native="openStockPopup(recommendation, 'recoPopup')">
                  <div class="card-header">
                    <div class="stock-info">
                      <img :src="recommendation.stock_logo" class="stock-logo" />
                      <span class="stock-name">{{ recommendation.stock_name }}</span>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="target-info">
                      <span class="remaining-target">Remaining Target</span>
                      <!-- <el-button class="action-btn" :style="{ backgroundColor: getButtonColor(recommendation.reco) }" @click.stop="openStockPopup(recommendation, 'trade')">
                        {{ recommendation.reco }}
                      </el-button> -->

                      <div>
                        <el-button class="action-btn" :style="{ backgroundColor: getButtonColor(recommendation.reco) }" @click.stop="openStockPopup(recommendation, 'trade')" v-if="userProfile && !currentEnvironment.byPassLogin && !currentEnvironment.isStockAntsAuth && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'BlinkX' && userProfile.utm_source != 'AngelOne' && userProfile.utm_source != '5 Paisa' && userProfile.utm_source != 'Dhan' && userProfile.utm_source != 'Finvasia' && userProfile.utm_source != 'Zerodha'">
                          {{ recommendation.reco }}
                        </el-button>

                        <el-button class="action-btn" :style="{ backgroundColor: getButtonColor(recommendation.reco) }" @click.stop="getTradeHostDetails()" v-else-if="currentEnvironment.byPassLogin && currentEnvironment.isHybridModel">
                          {{ recommendation.reco }}
                        </el-button>

                        <el-button class="action-btn" :style="{ backgroundColor: getButtonColor(recommendation.reco) }" style="cursor: not-allowed" @click.stop="" v-else>
                          {{ recommendation.reco }}
                        </el-button>
                      </div>
                    </div>
                    <div class="value-section">
                      <span class="value-percent">{{ recommendation.remaining_potential }}%</span>
                    </div>
                  </div>
                </el-card>
                <div class="footer-info" :style="{ borderRight: '3px solid ' + getBorderColor(recommendation.risk_tag) }">
                  <el-tooltip effect="dark" placement="top">
                    <template #content>
                      <div>
                        <strong>{{ recommendation.user_detail.name }}</strong>
                        <br />
                        SEBI Reg: {{ recommendation.user_detail.sebi_regi_number }}
                      </div>
                    </template>
                    <div>
                      <img class="user-profile_pic" :src="serverHostName + '/Media/' + recommendation.user_detail.profile_pic"  v-if="recommendation.user_detail.profile_pic" />
                      <img class="user-profile_pic" src="../assets/images/navBar/avatar.jpg" v-else />
                    </div>
                  </el-tooltip>
                  <span class="timestamp">
                    {{ formatTimestamp(recommendation.created_at) }}
                  </span>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- No Data Found Component -->
    <NoDataFound v-else />
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';
import moment from 'moment';

export default {
  props: ['recommendations', 'isRecoListLoading'],
  name: 'LatestRecommendations',

  components: {
    NoDataFound,
  },
  data() {
    return {
      isApiLoading: false, // API call state
      serverHostName: serverHostName,
      currentEnvironment: {},
    };
  },
  mounted() {
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

      this.hostUrl = this.currentEnvironment.hostUrl;
    }
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    // Limit to 8 recommendations & split into groups of 4
    chunkedRecommendations() {
      const limited = this.recommendations.slice(0, 8);
      const chunkSize = 4;
      return Array.from({ length: Math.ceil(limited.length / chunkSize) }, (_, index) => limited.slice(index * chunkSize, index * chunkSize + chunkSize));
    },
  },
  methods: {
    openStockPopup(reco, action) {
      this.$emit('get_reco_details', reco, action);
    },

    getTradeHostDetails() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },

    formatTimestamp(timestamp) {
      return moment(timestamp).format('MMM DD, YYYY, h:mm A');
    },
    getButtonColor(reco) {
      return reco === 'Buy' ? '#0BA042' : reco === 'Sell' ? '#EA2526' : '#ffc107';
    },
    getBorderColor(risk) {
      return risk === 'low_risk' ? '#0BA042' : risk === 'high_risk' ? '#EA2526' : '#ffc107';
    },
  },
};
</script>

<style lang="scss" scoped>
.latest-recommendations {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 10px;
    width: calc(100% - 10px);

    .view-all {
      font-size: 14px;
      font-weight: 500;
      color: #2d2e8d;
      text-decoration: none;
      cursor: pointer;
      transition: color 0.3s ease;

      &:hover {
        color: #0e4bf1;
      }
    }
  }

  .scroll-container {
    display: flex;
    overflow-x: auto;
    // padding-bottom: 10px;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .recommendation-card {
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0px 0px;
    flex-shrink: 0;
    cursor: pointer;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .stock-info {
        display: flex;
        align-items: center;

        .stock-logo {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 5px;
        }

        .stock-name {
          font-size: 13px;
          font-weight: 600;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; /* Limits the text to 2 lines */
          -webkit-box-orient: vertical;
          max-width: 200px;
          color: #000000;
          margin-right: 5px;
        }
      }
    }

    .card-body {
      .target-info {
        display: flex;
        justify-content: space-between;
        font-size: 11px;
        margin-top: 10px;

        .remaining-target {
          font-size: 10px;
          font-weight: 500;
        }

        .action-btn {
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          color: #ffffff;
          text-transform: uppercase;
          border: none;
        }
      }

      .value-section {
        margin-top: -10px;
      }

      .value-percent {
        font-size: 15px;
        font-weight: 600;
        color: #0ba042;
      }
    }
  }

  .footer-info {
    background-color: #e8eef5;
    padding: 5px 10px;
    border-radius: 0 0 10px 10px;
    display: flex;
    align-items: center;

    .user-profile_pic {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      margin-right: 5px;
    }

    .timestamp {
      font-size: 10px;
      font-weight: 500;
      color: #5e5e5e;
    }
  }
}

@media (max-width: 1140px) {
  .el-col {
    width: 50% !important;
    flex-shrink: 0;
  }
}

@media (min-width: 769px) {
  .el-col {
    width: 25%;
    flex-shrink: 0;
  }
}

@media (max-width: 768px) {
  .latest-recommendations {
    .recommendation-card {
      .card-header {
        .stock-info {
          .stock-logo {
            width: 30px;
            height: 30px;
          }

          .stock-name {
            font-weight: 600;
            font-size: 12px;
            max-width: 90px;
          }
        }
      }

      .card-body {
        .target-info {
          .remaining-target {
            font-size: 9px;
            font-weight: 500;
          }

          .action-btn {
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 9px;
            font-weight: 500;
          }
        }

        .value-section {
          margin-top: -5px;
        }

        .value-percent {
          font-size: 12px;
          font-weight: 600;
          color: #0ba042;
        }
      }
    }

    .footer-info {
      .user-profile_pic {
        width: 15px;
        height: 15px;
      }

      .timestamp {
        font-size: 9px;
        font-weight: 500;
      }
    }
  }
  .el-col {
    width: 50% !important;
    flex-shrink: 0;
    padding: 0px 5px 0px 7px !important;
  }
}
</style>
<style lang="scss">
.carousel-items {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 150px; // 100px image + 20px space for dots
  overflow: hidden;

  .el-carousel__container {
    padding-bottom: 0 !important;
    margin-bottom: 10px !important;
    height: 150px !important;
  }

  .el-carousel__indicators--outside {
    position: absolute !important;
    bottom: 2px !important;
    left: 50%;
    transform: translateX(-50%);
  }

  .el-carousel__indicator--horizontal {
    width: auto;
    padding: 5px;

    button {
      width: 8px !important;
      height: 8px !important;
      border-radius: 50% !important;
      background-color: #bbb !important;
      transition: background-color 0.3s ease;
    }

    &.is-active button {
      background-color: #2d2e8d !important;
    }
  }
}
</style>